import { render, staticRenderFns } from "./MatchBet.vue?vue&type=template&id=42393e72&scoped=true"
import script from "./MatchBet.vue?vue&type=script&lang=js"
export * from "./MatchBet.vue?vue&type=script&lang=js"
import style0 from "./MatchBet.vue?vue&type=style&index=0&id=42393e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42393e72",
  null
  
)

export default component.exports